export default function UnauthorizedPage() {
  return <div>You do not have permission to view this page.</div>;
}